import { css, html, LitElement, TemplateResult } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { sharedStyles } from "../styles/shared";
import { property } from "lit/decorators/property.js";
import { Size } from "shared";

@customElement("bs-card")
export class BsCard extends LitElement {
	@property({ type: String, reflect: true }) size: Size = "medium";
	@property({ type: Boolean, reflect: true }) hoverable = false;
	@property({ type: Boolean, reflect: true }) active = false;
	@property({ type: Boolean, reflect: true }) group = false;
	@property({ type: Boolean, reflect: true }) flat = false;
	@property({ type: Boolean, reflect: true }) transparent = false;

	static get styles() {
		return [
			sharedStyles,
			css`
				:host {
					--form-item-height: 32px;
					--_current-card-content-padding: var(--card-content-padding, var(--card-padding, var(--space-m)));
					--_current-card-header-footer-padding: var(--card-header-footer-padding, var(--card-padding, var(--space-m)));

					border-radius: var(--card-border-radius, var(--border-radius-l));
					/*border: 1px solid var(--shade-normal);*/
					background: var(--background);
					color: var(--foreground);
					box-shadow: var(--shadow) 0px 7px 10px -3px, var(--shadow) 0px -2px 6px -2px;
					border: var(--border, unset);
				}

				:host([group]) {
					height: var(--card-group-height, 40px);
					padding: var(--space-s) 0;
				}

				:host([flat]) {
					box-shadow: none;
					background: none;
					border: 1px solid var(--shade-normal);
					color: currentColor;
				}

				:host([transparent]) {
					background: rgba(var(--rgb), 0.7);
					backdrop-filter: blur(10px);

					-webkit-backdrop-filter: blur(10px);
				}

				:host([active]) {
					/* TODO */
					/*outline: 2px solid var(--card-outline-active, var(--focus-color));*/
					/*box-shadow: 0 0 0 2px var(--card-outline-active, var(--primary-normal));*/
					/*background: var(--card-bg-active, var(--shade-lighter));*/
					box-shadow: none;
					background: var(--card-bg-active, color-mix(in srgb, currentColor 10%, transparent));
					color: var(--card-color-active, var(--foreground));
					outline: var(--card-outline-active, unset);
					user-select: none;
					-webkit-user-select: none;
				}

				:host([size="small"]:not([flat])) {
					box-shadow: var(--shadow) 0px 5px 6px -2px, var(--shadow) 0px -1px 3px -1px;
				}

				:host([size="small"]:not([flat])[hoverable]:hover) {
					box-shadow: var(--shadow) 0px 8px 10px -1px, var(--shadow) 0px 1px 5px 0px;
				}

				:host([size="large"]) {
					--_current-card-content-padding: var(--card-content-padding, var(--card-padding, var(--space-l)));
					--_current-card-header-footer-padding: var(
						--card-header-footer-padding,
						var(--card-padding, var(--space-xm) var(--space-l))
					);
				}

				:host([size="large"][group]) {
					--form-item-height: 38px;
					height: var(--card-group-height, 52px);
				}

				:host {
					display: flex;
					flex-direction: column;
				}

				:host([group]),
				:host([group]) ::slotted(*) {
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: row;
				}

				:host([group]) ::slotted(*),
				:host([group]) > * {
					height: 100%;
					padding: 0 var(--card-group-item-padding, var(--space-m));
				}

				:host([hoverable]) {
					transition: box-shadow 120ms ease-out, transform 120ms ease-out;
					cursor: pointer;
					user-select: none;
					-webkit-user-select: none;
				}

				:host(:not([active])[hoverable]:hover) {
					transform: scale(1.01);
					box-shadow: var(--shadow) 0px 10px 14px -1px, var(--shadow) 0px -1px 8px -1px;
					z-index: 12345;
				}

				:host([group]) ::slotted(:not(:last-child)) {
					border-right: 1px solid var(--shade-normal);
				}

				#footer,
				#header,
				::slotted(footer),
				::slotted(header) {
					padding: var(--_current-card-header-footer-padding, var(--space-m));
					display: flex;
					align-items: center;
					gap: var(--space-s);
				}

				#content,
				::slotted(article),
				::slotted(form) {
					padding: var(--_current-card-content-padding);
					flex-grow: 1;
					/*overscroll-behavior-y: contain; Caused a bug in Safari where even though overflow-y is not overflowing the contain kicks in and stops the event from propagating */
					overflow-y: auto;
					overflow-x: hidden;
				}

				#header,
				::slotted(header) {
					border-bottom: 1px solid var(--shade-normal);
					flex-shrink: 0;
				}

				#footer,
				::slotted(footer) {
					padding: var(--_current-card-header-footer-padding, var(--space-m));
					border-top: 1px solid var(--shade-normal);
					justify-content: flex-end;
					flex-shrink: 0;
				}
			`
		];
	}

	render(): TemplateResult | undefined {
		return html` <slot></slot> `;
	}
}
